import React from 'react';

function Badge() {
	return <div>Badge goes here</div>;
}

export default Badge;
